export function mundelyLinks(language: string) {
  const italian = language === "it";
  return {
    website: italian ? "https://mundely.it/it/" : "https://mundely.it/",
    faq: italian ? "https://mundely.it/faq-it" : "https://mundely.it/faq-en",
    contact: italian ? "https://mundely.it/it/contattaci/" : "https://mundely.it/contact-us/",
    privacy: italian ? "https://mundely.it/it/privacy-policy-it/" : "https://mundely.it/privacy-policy-en/",
    terms: italian ? "https://mundely.it/it/termini-e-condizioni/" : "https://mundely.it/terms-and-conditions/",
    instagram: "https://www.instagram.com/mundelyapp/",
    facebook: "https://www.facebook.com/mundelyapp",
    youtube: "https://www.youtube.com/@mundelyapp"
  };
}